/**
 * 状態バッジ(設計書 §3-3)。色だけで伝えず、必ずアイコン＋文字を出す。業務ロジックは持たない
 * (どの状態かは呼び出し側が判定して kind で渡す)。
 */
import type { ComponentType } from 'react';
import { IconAlertCircle, IconAlertTriangle, IconCheck, IconCheckCircle, IconClock, IconFileWarning, IconInfo, IconMinus } from '@core/components/icons';

export type StatusKind = 'danger' | 'warning' | 'success' | 'notEntered' | 'unconfirmed' | 'confirmed' | 'noData' | 'info';
export type StatusTone = 'danger' | 'warning' | 'success' | 'info' | 'neutral';

const KINDS: Record<StatusKind, { label: string; tone: StatusTone; Icon: ComponentType<{ size?: number }> }> = {
  danger: { label: '要対応', tone: 'danger', Icon: IconAlertCircle },
  warning: { label: '注意', tone: 'warning', Icon: IconAlertTriangle },
  success: { label: '正常', tone: 'success', Icon: IconCheckCircle },
  notEntered: { label: '未入力', tone: 'warning', Icon: IconFileWarning },
  unconfirmed: { label: '未確認', tone: 'warning', Icon: IconClock },
  confirmed: { label: '確認済', tone: 'success', Icon: IconCheck },
  noData: { label: 'データなし', tone: 'neutral', Icon: IconMinus },
  info: { label: '情報', tone: 'info', Icon: IconInfo },
};

export default function StatusBadge({ kind, label, title }: { kind: StatusKind; /** 既定の文言を置き換える(例「超過」) */ label?: string; title?: string }) {
  const k = KINDS[kind];
  return (
    <span className={`status-badge tone-${k.tone}`} title={title}>
      <k.Icon size={14} />
      <span>{label ?? k.label}</span>
    </span>
  );
}
